var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"currencyamount"},[_c('span',{staticClass:"currency"},[_vm._v(_vm._s(_vm.currency))]),_c('span',{staticClass:"amount"},[_vm._v(_vm._s(_vm.formatNumber(_vm.amount / 100)))])])}
var staticRenderFns = []

export { render, staticRenderFns }